import gql from "graphql-tag";

export default {
  mutation: gql`
    mutation removeProcessingRole($role: String!) {
      deleteProcessingRole(role: $role) {
        success
      }
    }
  `,
  mutationName: "removeProcessingRole",
};



// WEBPACK FOOTER //
// ./src/model/gql/mutations/users/processingRole/removeProcessingRole.js